import { getСontracts} from "@/api/contracts";

const getDefaultState = () => {
    return {
        contracts: [],
        contractsLoading: true,

        pagination: {
            pageList: {
              active: false,
              pages: []
            },
            currentPage: 1,
            lastPage: 0
        },
    }
}

export default {
    namespaced: true,
    state: getDefaultState(),
    actions: {
        getContracts({ commit, state }, params, perPage= 10, currentPage = 1) {
            const sort = params?.sort || "id"
            const search = params?.search || ""
            commit("SET_CONTRACTS_LOADING", true);
            currentPage = state.pagination.currentPage
            getСontracts(perPage, currentPage, sort, search)
                .then(res => {
                    commit("SET_CONTRACTS", res.data)
                    // commit("SET_CONTRACTS_LIST_PAGINATION", res.headers)
                })
                .finally(() => commit("SET_CONTRACTS_LOADING", false));
        },
        clearData({ commit }) {
            commit("INIT_STATE");
        },

        // pagination
        getContractsListPage ({ commit, dispatch }, params) {
            commit('SET_CURRENT_PAGE', params.page)
            dispatch('getContracts', params)
        },
    },
    mutations: {
        SET_CONTRACTS(state, contracts) {
            state.contracts = contracts
        },
        ADD_CONTRACT(state, contract) {
            state.contracts.push(contract)
        },
        SET_CONTRACTS_LOADING(state, loading) {
            state.contractsLoading = loading
        },
        INIT_STATE(state) {
            Object.assign(state, getDefaultState());
        },
        // pagination
        // SET_CONTRACTS_LIST_PAGINATION: (state, headers) => {
        //     state.pagination.currentPage = Number(headers['x-pagination-current-page'])
        //     state.pagination.lastPage = Number(headers['x-pagination-page-count'])
        //     // заполняем массив номерами страниц от 1 до последней страницы
        //     state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
        // },
        RESET_CONTRACTS_LIST_CURRENT_PAGE: (state) => {
            state.pagination.currentPage = 1
        },
        SET_CURRENT_PAGE: (state, pageNum) => {
            state.pagination.currentPage = pageNum
        },
    },
    // getters: {
    //     getContractsListPagination: state => state.pagination,
    // }
}